import {Text} from '@react-pdf/renderer';

import {getFileNameListForPdf, sortAttachmentsByOrderIndex} from '../documents/helpers';
import {stylesForPdf} from './PdfPostControlStyling';


export const PdfPostControlDocumentAttachments = ({attachments, attachmentsInDocument}) => {
  attachments = attachments || [];
  if (!attachmentsInDocument.length) {
    return <Text>Brak załączników.</Text>
  }
  let attachmentsInDocumentArray = []
  attachmentsInDocument.map(attachment => {
    attachments.map(att => {
      if(attachment.documentId === att.id){
          attachmentsInDocumentArray.push(att);
      }
    })
  })
  const uniqueAttachments = attachmentsInDocumentArray.filter((obj, index) => {
    return index === attachmentsInDocumentArray.findIndex(o => obj.id === o.id);
  });

  attachments = getFileNameListForPdf(uniqueAttachments)
      .sort(sortAttachmentsByOrderIndex);
  return (
      <>
        {attachments.map((fileName, index) => {
            const fileNo = index + 1;
            return <Text key={index} style={stylesForPdf.attachment}>{`${fileNo}. ${fileName}`}</Text>
        })}
      </>
  )
};
